import paperLoad from "../../Assets/Icons/paper-load.svg";
import paperRolling from "../../Assets/Icons/tissue-rolling.svg";
import groupSet from "../../Assets/Icons/group-set.svg";
import track from "../../Assets/Icons/track.svg";
import userM from "../../Assets/Icons/user2.svg";
import stocks from "../../Assets/Icons/stocks.svg";

import paperLoad2 from "../../Assets/Icons/paper-load2.svg";
import paperRolling2 from "../../Assets/Icons/tissue-rolling2.svg";
import groupSet2 from "../../Assets/Icons/group-set2.svg";
import track2 from "../../Assets/Icons/track2.svg";
import userM2 from "../../Assets/Icons/user3.svg";
import stocks2 from "../../Assets/Icons/stocks_header.svg";

import Iconmoon from "../../Components/IconsFiles/icon";

export const iconsMapping = [
  {
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Iconmoon icon="setting" size={20} color="#E1DFDD" />
        <span>Configurations</span>
      </div>
    ),
    value: "../../Assets/Icons/setting.svg",
    icon: {
      active: <Iconmoon icon="setting" size={20} color="#ea655b" />,
      inactive: <Iconmoon icon="setting" size={20} color="#BFBFBF" />,
    },
  },
  {
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img src={paperLoad} alt="Order Management" style={{ height: "20px", width: "20px" }} />
        <span>Order Management</span>
      </div>
    ),
    value: "../../Assets/Icons/paper-load.svg",
    icon: {
      active: <img src={paperLoad2} alt="Order Management Active" style={{ height: "20px", width: "20px" }} />,
      inactive: <img src={paperLoad} alt="Order Management Inactive" style={{ height: "20px", width: "20px" }} />,
    },
  },
  {
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img src={paperRolling} alt="Deckle Management" style={{ height: "20px", width: "20px" }} />
        <span>Deckle Management</span>
      </div>
    ),
    value: "../../Assets/Icons/tissue-rolling.svg",
    icon: {
      active: <img src={paperRolling2} alt="Deckle Management Active" style={{ height: "20px", width: "20px" }} />,
      inactive: <img src={paperRolling} alt="Deckle Management Inactive" style={{ height: "20px", width: "20px" }} />,
    },
  },
  {
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img src={groupSet} alt="Organization Settings" style={{ height: "20px", width: "20px" }} />
        <span>Organization Settings</span>
      </div>
    ),
    value: "../../Assets/Icons/group-set.svg",
    icon: {
      active: <img src={groupSet2} alt="Organization Settings Active" style={{ height: "20px", width: "20px" }} />,
      inactive: <img src={groupSet} alt="Organization Settings Inactive" style={{ height: "20px", width: "20px" }} />,
    },
  },
  {
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img src={track} alt="Production Planning" style={{ height: "20px", width: "20px" }} />
        <span>Production Planning</span>
      </div>
    ),
    value: "../../Assets/Icons/track.svg",
    icon: {
      active: <img src={track2} alt="Production Planning Active" style={{ height: "20px", width: "20px" }} />,
      inactive: <img src={track} alt="Production Planning Inactive" style={{ height: "20px", width: "20px" }} />,
    },
  },
  {
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img src={stocks} alt="Stock Management" style={{ height: "20px", width: "20px" }} />
        <span>Stock Management</span>
      </div>
    ),
    value: "../../Assets/Icons/stocks.svg",
    icon: {
      active: <img src={stocks2} alt="Stock Management Active" style={{ height: "20px", width: "20px" }} />,
      inactive: <img src={stocks} alt="Stock Management Inactive" style={{ height: "20px", width: "20px" }} />,
    },
  },
  {
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img src={userM} alt="Profile Settings" style={{ height: "20px", width: "20px" }} />
        <span>Profile Settings</span>
      </div>
    ),
    value: "../../Assets/Icons/user2.svg",
    icon: {
      active: <img src={userM2} alt="Profile Settings Active" style={{ height: "20px", width: "20px" }} />,
      inactive: <img src={userM} alt="Profile Settings Inactive" style={{ height: "20px", width: "20px" }} />,
    },
  },
];
